import React from 'react';
import { StyleSheet } from 'react-native';
import { Divider as PaperDivider } from 'react-native-paper';
export function Divider({ style }) {
    return React.createElement(PaperDivider, { style: [styles.divider, style] });
}
const styles = StyleSheet.create({
    divider: { width: '100%' },
});
